import { atom, injectStore, injectAtomValue, injectEffect, ion } from '@zedux/react';
import { Socket } from 'socket.io-client';
import { socketAtom, userInfoAtom } from './socket';
import { IUserInfo } from '../types';



export const onlineUsersAtom = atom("online_users", () => {

    const store = injectStore(new Set<number>());
    const socket = injectAtomValue(socketAtom)
    const userInfo = injectAtomValue(userInfoAtom)

    injectEffect(() => {
        console.log("setting up online users atom effect with socket ", socket, " and userInfo ", userInfo)
        if (socket && userInfo && userInfo.userId) {

            socket.on("online_users", (users) => {
                console.log("online users received ", users);
                store.setState(new Set(users));
            });

            socket.on('user_status_change', ({ userId, isOnline }) => {
                // console.log("user status change received for user ", userId, " isOnline ", isOnline)
                store.setState((state) => {
                    const newState = new Set(state);
                    if (isOnline) {
                        newState.add(userId)
                    } else {
                        newState.delete(userId)
                    }
                    return newState;
                });
            });

            socket.emit("request_online_users")

            return () => {
                socket.off("online_users");
                socket.off("user_status_change")
            };
        }
    }, [socket, userInfo, userInfo?.userId])

    return store
})


export const isUserOnlineSelector = ion("is_user_online", ({ get }, userId?: number | null) => {
    const onlineUsers = get(onlineUsersAtom);
    return userId != null && onlineUsers.has(userId);
})